import {
	createSlice,
	current
} from '@reduxjs/toolkit';
import {
	getNormativeEstablishmentList,
	addNewNormativeEstablishment,
	updateNormativeEstablishment,
	deleteNormativeEstablishment,
	getNormativeEstablishment,
	getNormativeEstablishmentDetail,
} from './thunk';

export const initialState = {
	itemNormativeEstablishmentList: [],
	itemNormativeEstablishmentDetail: null,
	isNormativeEstablishmentLoading: false,
	isNormativeEstablishmentSuccess: false,

	normativeEstablishmentList: [],
	normativeEstablishmentListSelect: [],
	isLoadingList: false,
	isAdding: false,
	isAdded: false,
	isAddError: false,
	isUpdating: false,
	isUpdated: false,
	isUpdateError: false,
	isDeleting: false,
	isDeleted: false,
	isDeleteError: false,
	requireCloseModal: false,
};

const NormativeEstablishmentSlice = createSlice({
	name: 'NormativeEstablishments',
	initialState,
	reducers: {
		setRequireCloseModal(state, action) {
			state.requireCloseModal = action.payload;
		},
	},
	extraReducers: builder => {
		builder.addCase(getNormativeEstablishment.fulfilled, (state, action) => {
			state.isNormativeEstablishmentLoading = false;
			state.isNormativeEstablishmentSuccess = true;
			state.itemNormativeEstablishmentDetail = action.payload;
			state.isLoadingList = false;
		});
		builder.addCase(getNormativeEstablishment.pending, state => {
			state.isNormativeEstablishmentLoading = true;
			state.isNormativeEstablishmentSuccess = null;
			state.error = null;
			state.isLoadingList = true;
		});
		builder.addCase(getNormativeEstablishment.rejected, (state, action) => {
			state.isNormativeEstablishmentLoading = false;
			state.isNormativeEstablishmentSuccess = false;
			state.error = action.error.message;
			state.isLoadingList = false;
		});

		builder.addCase(getNormativeEstablishmentList.pending, state => {
			state.isNormativeEstablishmentSuccess = true;
			state.error = null;
			state.isLoadingList = true;
		});
		builder.addCase(getNormativeEstablishmentList.fulfilled, (state, action) => {
			state.itemNormativeEstablishmentList = action.payload;
			state.normativeEstablishmentList = action.payload;
			state.isLoadingList = false;
			state.isNormativeEstablishmentSuccess = true;

			let normativeEstablishmentListSelect = [];
			action.payload.map(item =>
				normativeEstablishmentListSelect.push({
					item: item,
					value: item._id,
					label: item.name,
				})
			);

			state.normativeEstablishmentListSelect = normativeEstablishmentListSelect;
		});
		builder.addCase(getNormativeEstablishmentList.rejected, (state, action) => {
			state.error = action.payload || null;
			state.isLoadingList = false;
			state.isNormativeEstablishmentSuccess = true;
		});
		builder.addCase(addNewNormativeEstablishment.fulfilled, (state, action) => {
			state.itemNormativeEstablishmentList.push(action.payload);
			state.normativeEstablishmentList.push(action.payload);
			state.isLoadingList = false;
			state.isAdding = false;
			state.isAdded = true;
			state.isAddError = false;
			state.requireCloseModal = true;
		});
		builder.addCase(addNewNormativeEstablishment.pending, (state, action) => {
			state.isLoadingList = true;
			state.isAdding = true;
			state.isAdded = false;
			state.isAddError = false;
		});
		builder.addCase(addNewNormativeEstablishment.rejected, (state, action) => {
			state.error = action.payload || null;
			state.isLoadingList = false;
			state.isAdding = false;
			state.isAdded = false;
			state.isAddError = true;
		});

		builder.addCase(updateNormativeEstablishment.fulfilled, (state, action) => {
			state.itemNormativeEstablishmentList = state.itemNormativeEstablishmentList.map(normativeEstablishment =>
				normativeEstablishment.normativeEstablishmentname === action.payload.old_normativeEstablishment
					? { ...normativeEstablishment, ...action.payload.updated_normativeEstablishment }
					: normativeEstablishment
			);
			state.normativeEstablishmentList = state.normativeEstablishmentList.map(normativeEstablishment =>
				normativeEstablishment._id.toString() === action.payload._id.toString()
					? { ...normativeEstablishment, ...action.payload }
					: normativeEstablishment
			);
			state.isLoadingList = false;
			state.isUpdating = false;
			state.isUpdated = true;
			state.isUpdateError = false;
			state.requireCloseModal = true;
		});
		builder.addCase(updateNormativeEstablishment.pending, state => {
			state.isLoadingList = true;
			state.isUpdating = true;
			state.isUpdated = false;
			state.isUpdateError = false;
		});
		builder.addCase(updateNormativeEstablishment.rejected, (state, action) => {
			state.error = action.payload || null;
			state.isLoadingList = false;
			state.isUpdating = false;
			state.isUpdated = false;
			state.isUpdateError = true;
		});

		builder.addCase(deleteNormativeEstablishment.fulfilled, (state, action) => {
			state.itemNormativeEstablishmentList = current(state.itemNormativeEstablishmentList).filter(
				item => item._id !== action.payload._id
			);
			state.normativeEstablishmentList = current(state.normativeEstablishmentList).filter(item =>
				item._id !== action.payload._id
			);
			state.isLoadingList = false;
			state.isDeleting = false;
			state.isDeleted = true;
			state.isDelete = false;
			state.requireCloseModal = true;
		});
		builder.addCase(deleteNormativeEstablishment.pending, (state, action) => {
			state.isLoadingList = true;
			state.isDeleting = false;
			state.isDeleted = true;
			state.isDelete = false;
		});
		builder.addCase(deleteNormativeEstablishment.rejected, (state, action) => {
			state.error = action.payload || null;
			state.isLoadingList = false;
			state.isDeleting = false;
			state.isDeleted = false;
			state.isDelete = true;
		});

		
		builder.addCase(getNormativeEstablishmentDetail.fulfilled, (state, action) => {
			state.isNormativeEstablishmentLoading = false;
			state.isNormativeEstablishmentSuccess = true;
			state.itemNormativeEstablishmentDetail = action.payload;
			state.isLoadingList = false;
		});
		builder.addCase(getNormativeEstablishmentDetail.pending, state => {
			state.isNormativeEstablishmentLoading = true;
			state.isNormativeEstablishmentSuccess = null;
			state.error = null;
			state.isLoadingList = true;
		});
		builder.addCase(getNormativeEstablishmentDetail.rejected, (state, action) => {
			state.isNormativeEstablishmentLoading = false;
			state.isNormativeEstablishmentSuccess = false;
			state.error = action.error.message;
			state.isLoadingList = false;
		});

	},
});

export const { setRequireCloseModal } = NormativeEstablishmentSlice.actions;

export default NormativeEstablishmentSlice.reducer;
